import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import FormContainer from "../components/FormContainer";

function GuestScreen({ location }) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [country, setCountry] = useState("");

  const submitHandler = (e) => {
    e.preventDefault();
    // Send the collected information to the Mailchimp API
    fetch(
      "https://lstractorusa.us21.list-manage.com/subscribe/post?u=53370a9713db15501f6d9e678&id=4a4607861b",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          EMAIL: email,
          PHONE: phone,
          FNAME: first_name,
          "ADDRESS[addr1]": address,
          "ADDRESS[city]": city,
          "ADDRESS[state]": state,
          "ADDRESS[zip]": postalCode,
          "ADDRESS[country]": country,
        }).toString(),
      }
    )
      .then((response) => {
        // Handle the response from the Mailchimp API
        if (response.ok) {
          // Success
          console.log("Subscription successful");
        } else {
          // Error
          console.error("Subscription failed");
        }
      })
      .catch((error) => {
        console.error("An error occurred", error);
      });
    // console.log("Form Submitted", { email, address, city, postalCode, country });
  };

  return (
    <FormContainer>
      <h2>
        Let's connect you with our network of trusted and reliable dealers!
      </h2>
      <Form onSubmit={submitHandler}>
        <Form.Group controlId="email">
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            className="rounded"
            type="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        <br></br>
        <Form.Group controlId="phone">
          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            className="rounded"
            type="text"
            placeholder="Enter phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}

            required
          />
        </Form.Group>
        <br></br>
        <Form.Group controlId="first_name">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            className="rounded"
            type="text"
            placeholder="Enter first name"
            value={first_name}
            onChange={(e) => setFirst_name(e.target.value)}
            required
          />
        </Form.Group>
        <br></br>
        <Form.Group controlId="address">
          <Form.Label>Address</Form.Label>
          <Form.Control
            className="rounded"
            type="text"
            placeholder="Enter address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
          />
        </Form.Group>
        <br></br>
        <Form.Group controlId="city">
          <Form.Label>City</Form.Label>
          <Form.Control
            className="rounded"
            type="text"
            placeholder="Enter city"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            required
          />
        </Form.Group>
        <br></br>
        <Form.Group controlId="state">
          <Form.Label>State</Form.Label>
          <Form.Control
            className="rounded"
            type="text"
            placeholder="Enter state"
            value={state}
            onChange={(e) => setState(e.target.value)}
            required
          />
        </Form.Group>
        <br></br>
        <Form.Group controlId="postalCode">
          <Form.Label>Postal Code</Form.Label>
          <Form.Control
            className="rounded"
            type="text"
            placeholder="Enter postal code"
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
            required
          />
        </Form.Group>
        <br></br>
        <Form.Group controlId="country">
          <Form.Label>Country</Form.Label>
          <Form.Control
            className="rounded"
            type="text"
            placeholder="Enter country"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            required
          />
        </Form.Group>
        <br></br>
        <Button type="submit" variant="primary" className="button std">
          Continue
        </Button>
      </Form>
    </FormContainer>
  );
}

export default GuestScreen;
